import React from 'react'
import { Button, Grid, Typography } from '@material-ui/core'

import BaseFilterModal from '../../../components/hooks/BaseFilterModal'
import filterStylesComponents from '../../../assets/filterComponentsStyles'
import colors from '../../../assets/colors'

// Confirmação no padrão dos modais de atendimento (Arquivar OS / Deletar serviço)
const ConfirmModal = ({
  open,
  title,
  message,
  confirmText = 'Confirmar',
  onClose,
  onConfirm,
}) => {
  const classes = filterStylesComponents()

  return (
    <BaseFilterModal
      open={open}
      title={title}
      hiddenHelpButton
      handleOpen={onClose}
    >
      <Grid item xs={12} style={{ width: '320px', maxWidth: '100%' }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography style={{ color: colors.gray, fontSize: 14 }}>
              {message}
            </Typography>
          </Grid>

          <Grid
            item
            xs={12}
            container
            alignItems="center"
            justifyContent="flex-end"
          >
            <Button
              type="button"
              onClick={onClose}
              className={classes.btnMoreFilters}
            >
              Cancelar
            </Button>

            <Button
              type="button"
              onClick={onConfirm}
              className={classes.btnAdd}
            >
              {confirmText}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </BaseFilterModal>
  )
}

export default ConfirmModal
